"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31579 3.33333C9.31579 3.12342 9.47052 3 9.60527 3H12.7632C12.8979 3 13.0526 3.12342 13.0526 3.33333V12.6667C13.0526 12.8766 12.8979 13 12.7632 13H9.60527C9.47052 13 9.31579 12.8766 9.31579 12.6667V3.33333ZM9.60527 2C8.86798 2 8.31579 2.62277 8.31579 3.33333V12.6667C8.31579 13.3772 8.86798 14 9.60527 14H12.7632C13.5004 14 14.0526 13.3772 14.0526 12.6667V3.33333C14.0526 2.62277 13.5004 2 12.7632 2H9.60527ZM3 8.00002C3 7.79011 3.15473 7.66669 3.28947 7.66669H5.81579C5.95053 7.66669 6.10526 7.79011 6.10526 8.00002V12.6667C6.10526 12.8766 5.95053 13 5.81579 13H3.28947C3.15473 13 3 12.8766 3 12.6667V8.00002ZM3.28947 6.66669C2.55219 6.66669 2 7.28946 2 8.00002V12.6667C2 13.3773 2.55219 14 3.28947 14H5.81579C6.55307 14 7.10526 13.3773 7.10526 12.6667V8.00002C7.10526 7.28946 6.55307 6.66669 5.81579 6.66669H3.28947Z",
    fill: fill
  }));
};

exports["default"] = _default;